import { Badge, Box, Typography } from '@mui/material';

const EmojiOutcomeBox = ({ score, emoji, teamTotal }) => (
  <>
    <Box display="flex" justifyContent={'center'} alignItems={'center'}>
      <Typography variant="h2" role="img" aria-label="Trophy">
        {emoji}
      </Typography>
      <Typography variant="caption" ml={1}>
        {score && `(${score})`}
      </Typography>
    </Box>
  </>
);

export default EmojiOutcomeBox;
